import NegativeFaceIcon from "src/icons/conversationSentiment/NegativeFaceIcon";
import NeutralFaceIcon from "src/icons/conversationSentiment/NeutralFaceIcon";
import PositiveFaceIcon from "src/icons/conversationSentiment/PositiveFaceIcon";
import theme from "src/theme";
import { capitalize, removeUnderscore } from "@utils";

export const formatClickType = (value) => capitalize(removeUnderscore(value).toLowerCase());

export const CHIP_TYPES = {
  POSITIVE: { TYPE: "POSITIVE", BG_COLOR: theme.palette.success[200], COLOR: theme.palette.success[600], HOVER: "#CCE8DE" },
  NEGATIVE: { TYPE: "NEGATIVE", BG_COLOR: "#FEF0F3", COLOR: "#B9133A", HOVER: "#FFD7DF" },
  NEUTRAL: { TYPE: "NEUTRAL", BG_COLOR: "#EDF5FF", COLOR: "#41689E", HOVER: "#DAE9FF" },
  SYSTEM_MESSAGE: { TYPE: "SYSTEM_MESSAGE", BG_COLOR: "#FFFFFF", COLOR: theme.palette.grey[600], HOVER: theme.palette.grey[100] },
  DEFAULT: { TYPE: "DEFAULT" }
};

export const USER_SENTIMENT_CHIPS = {
  POSITIVE: { TYPE: "Positive", COLOR: theme.palette.success[500], ICON: PositiveFaceIcon },
  NEUTRAL: { TYPE: "Neutral", COLOR: "#5F98E8", ICON: NeutralFaceIcon },
  NEGATIVE: { TYPE: "Negative", COLOR: "#EF404B", ICON: NegativeFaceIcon }
};
export const SYSTEM_MESSAGE_EVENTS = {
  AGENT_CONNECTED: "AGENT_CONNECTED",
  SUGGESTION_CLICK: "SUGGESTION_CLICK",
  URL_TAG_CLICK: "URL_TAG_CLICK",
  SEARCH_PERFORMED: "SEARCH_PERFORMED",
  CALL_ENDED: "CALL_ENDED",
  WIDGET_LOAD: "WIDGET_LOAD",
  CONNECTION_EVENT: "CONNECTION_EVENT"
};

export const CHANNEL_TYPES = {
  WEB: "Web",
  PHONE: "Phone"
};

export const SIMPLE_VIEW_EVENTS = {
  PATIENT_IDENTIFIED_SUCCESSFULLY: "PATIENT_IDENTIFIED_SUCCESSFULLY",
  LINK_SENT: "LINK_SENT",
  APPOINTMENT_DETAILS_READ: "APPOINTMENT_DETAILS_READ",
  NUMBER_OF_EXISTING_APPOINTMENTS: "NUMBER_OF_EXISTING_APPOINTMENTS",
  CANCEL_APPOINTMENT_RESULT: "CANCEL_APPOINTMENT_RESULT",
  RESCHEDULE_APPOINTMENT_RESULT: "RESCHEDULE_APPOINTMENT_RESULT",
  ROUTED: "ROUTED",
  PATIENT_DATA_NOT_FOUND: "PATIENT_DATA_NOT_FOUND",
  IDENTIFICATION_REQUEST_FAILED: "IDENTIFICATION_REQUEST_FAILED",
  HANDOFF: "HANDOFF",
  MAP_CLICK: "MAP_CLICK",
  LIST_VIEW_CLICK: "LIST_VIEW_CLICK",
  CTA_CLICK: "CTA_CLICK",
  SUCCESSFUL_ROUTE_SELECTION: "SUCCESSFUL_ROUTE_SELECTION",
  RESULT_CLICK: "RESULT_CLICK",
  PROVIDER_FUTURE_TIME_SLOTS: "PROVIDER_FUTURE_TIME_SLOTS",
  APPOINTMENT_NOT_IN_MODIFICATION_WINDOW: "APPOINTMENT_NOT_IN_MODIFICATION_WINDOW",
  PATIENT_IDENTIFICATION: "PATIENT_IDENTIFICATION",
  NEW_APPOINTMENT_SCHEDULED: "NEW_APPOINTMENT_SCHEDULED",
  IN_BASKET_MESSAGE_SENT: "IN_BASKET_MESSAGE_SENT",
  FILL_REQUEST: "FILL_REQUEST",
  FEEDBACK_RESULT: "FEEDBACK_RESULT",
  ...SYSTEM_MESSAGE_EVENTS
};

export const EVENT_PROVIDER_TYPES = {
  TWILIO_DTMF: "TWILIO_DTMF"
};

export const EVENT_TYPES = {
  DTMF_COLLECTED: "DTMF_COLLECTED",
  AJAX_ACTION: "AJAX_ACTION",
  APPOINTMENT_BOOKED: "APPOINTMENT_BOOKED",
  BOT_UTTERANCE: "BOT_UTTERANCE",
  BOT_UTTERANCE_DIFF: "BOT_UTTERANCE_DIFF",
  BOT_UTTERANCE_FEEDBACK: "BOT_UTTERANCE_FEEDBACK",
  CONVERSATION_CONTEXT: "CONVERSATION_CONTEXT",
  CONVERSATION_START: "CONVERSATION_START",
  CONVERSATION_RECORDING: "CONVERSATION_RECORDING",
  CONVERSION: "CONVERSION",
  CANNED_RESPONSE: "CANNED_RESPONSE",
  DISAMBIGUATION: "DISAMBIGUATION",
  ERROR: "ERROR",
  EXTERNAL: "EXTERNAL",
  EXTERNAL_SEARCH: "EXTERNAL_SEARCH",
  FAQ_RESPONSE: "FAQ_RESPONSE",
  FEEDBACK_RESULT: "FEEDBACK_RESULT",
  HAND_OFF_TO_AGENT: "HAND_OFF_TO_AGENT",
  HANDOFF_TO_LEASING: "HANDOFF_TO_LEASING",
  HANDOFF_TO_PROPERTY: "HANDOFF_TO_PROPERTY",
  INFEASIBLE: "INFEASIBLE",
  INTENT: "INTENT",
  IS_LOOKING_TO_RENT: "IS_LOOKING_TO_RENT",
  KNOWLEDGE: "KNOWLEDGE",
  MATCHED_WORD_REVIEW_CLICK: "MATCHED_WORD_REVIEW_CLICK",
  MATCHED_WORD_REVIEW: "MATCHED_WORD_REVIEW",
  MOUSE_ENTER: "MOUSE_ENTER",
  MOUSE_LEAVE: "MOUSE_LEAVE",
  PHONE_TAG_CLICK: "PHONE_TAG_CLICK",
  SWITCH_COMMAND: "SWITCH_COMMAND",
  SITE_SEARCH_WITH_LLMS: "SITE_SEARCH_WITH_LLMS",
  THINKING: "THINKING",
  USER_UTTERANCE: "USER_UTTERANCE",
  WIDGET_CLICK: "WIDGET_CLICK",
  WIDGET_LOAD: "WIDGET_LOAD",
  CONNECTION_EVENT: "CONNECTION_EVENT",
  FACT_COLLECTED: "FACT_COLLECTED",
  CONVERSATION_TTL_REACHED: "CONVERSATION_TTL_REACHED",
  INTEGRATION_REQUEST_RESULT: "INTEGRATION_REQUEST_RESULT",
  INTEGRATION_REQUEST_ERROR: "INTEGRATION_REQUEST_ERROR",
  TRANSFER_DESTINATION_FROM_ROUTING_TABLES: "TRANSFER_DESTINATION_FROM_ROUTING_TABLES",
  OUTBOUND_CALL_RESOLUTION: "OUTBOUND_CALL_RESOLUTION",
  MISUNDERSTANDING: "MISUNDERSTANDING",
  ...SIMPLE_VIEW_EVENTS
};

export const UTTERANCE_TYPES = {
  VOICE: "voice"
};
